import { render, staticRenderFns } from "./AppScreenshots.vue?vue&type=template&id=039e280a"
import script from "./AppScreenshots.vue?vue&type=script&lang=js"
export * from "./AppScreenshots.vue?vue&type=script&lang=js"
import style0 from "./AppScreenshots.vue?vue&type=style&index=0&id=039e280a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports